import e from "../../managers/braze-instance.js";
import { hideContentCards, showContentCards } from "../index.js";
export function toggleContentCards(n, o) {
  e.X() &&
    (document.querySelectorAll(".ab-feed").length > 0
      ? hideContentCards()
      : showContentCards(n, o));
}
